// Scroll animations for timeline events
document.addEventListener('DOMContentLoaded', () => {
  // Add an animated background to the timeline
  const timelineSection = document.querySelector('.timeline');
  if (timelineSection) {
    timelineSection.style.position = 'relative';
    timelineSection.style.overflow = 'hidden';
    
    // Create animated background particles
    const particlesContainer = document.createElement('div');
    particlesContainer.className = 'timeline-particles';
    particlesContainer.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 0;
      opacity: 0.4;
    `;
    
    // Create particles
    for (let i = 0; i < 20; i++) {
      const particle = document.createElement('div');
      const size = Math.random() * 8 + 3;
      const posX = Math.random() * 100;
      const posY = Math.random() * 100;
      const duration = Math.random() * 20 + 10;
      const delay = Math.random() * 5;
      
      particle.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        border-radius: 50%;
        background-color: var(--primary-color);
        left: ${posX}%;
        top: ${posY}%;
        opacity: ${Math.random() * 0.5 + 0.1};
        animation: float ${duration}s ease-in-out ${delay}s infinite;
      `;
      
      particlesContainer.appendChild(particle);
    }
    
    timelineSection.prepend(particlesContainer);
    
    // Add float animation
    const floatStyle = document.createElement('style');
    floatStyle.textContent = `
      @keyframes float {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        25% { transform: translate(20px, -15px) rotate(5deg); }
        50% { transform: translate(-15px, -25px) rotate(-5deg); }
        75% { transform: translate(-25px, 15px) rotate(3deg); }
      }
    `;
    document.head.appendChild(floatStyle);
  }

  // Set up more dramatic animations for timeline events
  const style = document.createElement('style');
  style.textContent = `
    /* Timeline animated decorations */
    .timeline::after {
      content: '';
      position: absolute;
      left: 31px;
      top: 8rem;
      bottom: 2rem;
      width: 3px;
      background: linear-gradient(to bottom, transparent, var(--primary-color), var(--primary-color), transparent);
      opacity: 0;
      z-index: 1;
      transform-origin: top center;
      animation: pulseTimeline 2s ease-out forwards;
    }
    
    @keyframes pulseTimeline {
      0% { opacity: 0; height: 0; }
      50% { opacity: 0.8; }
      100% { opacity: 0.3; height: calc(100% - 10rem); }
    }
    
    /* Event animations */
    .event {
      opacity: 0;
      transform: translateX(-50px);
      filter: blur(5px);
      transition: all 0.8s cubic-bezier(0.17, 0.67, 0.83, 0.67);
    }
    
    .event.visible {
      opacity: 1;
      transform: translateX(0);
      filter: blur(0);
    }
    
    /* Circle animations */
    .event::before {
      transform: scale(0);
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
      transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), 
                  box-shadow 1.5s ease;
    }
    
    .event.visible::before {
      transform: scale(1);
      box-shadow: 0 0 0 15px rgba(255, 107, 107, 0);
      animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
      0% { box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7); }
      70% { box-shadow: 0 0 0 10px rgba(255, 107, 107, 0); }
      100% { box-shadow: 0 0 0 0 rgba(255, 107, 107, 0); }
    }
    
    /* Icon animations */
    .event-icon {
      opacity: 0;
      transform: scale(0.5) rotate(-45deg);
      transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
      transition-delay: 0.3s;
    }
    
    .event.visible .event-icon {
      opacity: 1;
      transform: scale(1) rotate(0deg);
      animation: iconWiggle 1s ease 1s 1;
    }
    
    @keyframes iconWiggle {
      0%, 100% { transform: rotate(0deg); }
      25% { transform: rotate(-10deg); }
      50% { transform: rotate(10deg); }
      75% { transform: rotate(-5deg); }
    }
    
    /* Content animations */
    .event-info {
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.7s ease;
      transition-delay: 0.5s;
    }
    
    .event.visible .event-info {
      opacity: 1;
      transform: translateY(0);
    }
    
    .event-info h3 {
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.5s ease;
      transition-delay: 0.6s;
    }
    
    .event.visible .event-info h3 {
      opacity: 1;
      transform: translateY(0);
    }
    
    .location {
      opacity: 0;
      transform: translateX(-20px);
      transition: all 0.5s ease;
      transition-delay: 0.7s;
    }
    
    .event.visible .location {
      opacity: 1;
      transform: translateX(0);
    }
    
    .description, .movie {
      opacity: 0;
      transform: translateX(20px);
      transition: all 0.5s ease;
      transition-delay: 0.8s;
    }
    
    .event.visible .description, 
    .event.visible .movie {
      opacity: 1;
      transform: translateX(0);
    }
    
    .feature-list li {
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.5s ease;
    }
    
    .event.visible .feature-list li:nth-child(1) {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.9s;
    }
    
    .event.visible .feature-list li:nth-child(2) {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 1.1s;
    }
    
    .event.visible .feature-list li:nth-child(3) {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 1.3s;
    }
    
    /* Time animations */
    .time {
      opacity: 0;
      transform: scale(1.5);
      transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      transition-delay: 0.2s;
    }
    
    .event.visible .time {
      opacity: 1;
      transform: scale(1);
    }
    
    /* Delay for sequential events */
    .event:nth-child(3) {
      transition-delay: 0.15s;
    }
    
    .event:nth-child(4) {
      transition-delay: 0.3s;
    }
  `;
  document.head.appendChild(style);

  // Set up Intersection Observer with higher threshold for more precise triggering
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        
        // Add sparkle effect to timeline circles when they become visible
        if (entry.target.classList.contains('event')) {
          setTimeout(() => {
            createSparkleEffect(entry.target);
          }, 1000);
        }
        
        // Once the animation has played, no need to observe anymore
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3, // Trigger when 30% of the element is visible
    rootMargin: '0px 0px -10% 0px' // Slightly adjust when animation triggers
  });

  // Observe all timeline events
  document.querySelectorAll('.event').forEach(event => {
    observer.observe(event);
  });
  
  // Function to create sparkle effect around timeline circles
  function createSparkleEffect(eventElement) {
    const rect = eventElement.getBoundingClientRect();
    const circle = eventElement.getBoundingClientRect();
    const circleX = circle.left - 40; // Adjust based on circle position
    const circleY = circle.top + window.scrollY + 32; // Adjust based on circle position
    
    for (let i = 0; i < 12; i++) {
      const sparkle = document.createElement('div');
      const angle = (i / 12) * 360;
      const distance = 30;
      
      const x = circleX + Math.cos(angle * Math.PI / 180) * distance;
      const y = circleY + Math.sin(angle * Math.PI / 180) * distance;
      
      sparkle.style.cssText = `
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: var(--primary-color);
        top: ${y}px;
        left: ${x}px;
        z-index: 10;
        pointer-events: none;
        opacity: 0;
      `;
      
      document.body.appendChild(sparkle);
      
      // Animate the sparkle
      anime({
        targets: sparkle,
        translateX: [0, Math.cos(angle * Math.PI / 180) * 20],
        translateY: [0, Math.sin(angle * Math.PI / 180) * 20],
        opacity: [0, 1, 0],
        scale: [1, 1.5, 0],
        easing: 'easeOutExpo',
        duration: 1500,
        complete: function() {
          document.body.removeChild(sparkle);
        }
      });
    }
  }
  
  // Load anime.js for advanced animations
  const animeScript = document.createElement('script');
  animeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/animejs/3.2.1/anime.min.js';
  animeScript.async = true;
  document.head.appendChild(animeScript);
}); 